import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M11.864 11.136a2.568 2.568 0 100-5.137 2.568 2.568 0 000 5.137m-2.856.624a4.296 4.296 0 115.717-.004l-.005.004c2.384 1.11 4.007 3.485 4.008 6.24A.864.864 0 1117 18a5.136 5.136 0 00-10.272 0A.864.864 0 115 18a6.86 6.86 0 013.966-6.222z" /></svg>;